import { onboardingHelper } from './onboardingHelper'

export function caseloadHelper() {
    return {
        filters: {
            grades: [],
            subjects: [],
            evaluators: [],
            experience: [],
            tipOptions: []
        },
        experienceRanges: [
            {
                label: '0-4',
                min: 0,
                max: 4
            },
            {
                label: '4-6',
                min: 4,
                max: 6
            },
            {
                label: '6-10',
                min: 6,
                max: 10
            },
            {
                label: '10+',
                min: 10,
                max: 100
            }
        ],
        componentCounts: [
            { component: '1a', MOTPComponentID: [23, 24], count: 0 },
            { component: '1e', MOTPComponentID: [31, 32], count: 0 },
            { component: '4e', MOTPComponentID: [30, 33], count: 0 },
            { component: '2a', MOTPComponentID: 25, count: 0 },
            { component: '2d', MOTPComponentID: 26, count: 0 },
            { component: '3b', MOTPComponentID: 27, count: 0 },
            { component: '3c', MOTPComponentID: 28, count: 0 },
            { component: '3d', MOTPComponentID: 29, count: 0 },
        ],
        tipOptions: [
            { label: 'Yes', value: true }, 
            { label: 'No', value: false }
        ],
        steps: [
            { 
                intro: `${ onboardingHelper().closeIconText('doneAdminLandingPageOnboarding') }
                    <h2>CASELOAD MANAGER</h2>
                    <p>Use the Caseload Manager tool to view your school's progress through the <i>Advance</i> observation process.</p>`
            },
            { 
                element: '.chart-and-stats',
                intro: `${ onboardingHelper().closeIconText('doneAdminLandingPageOnboarding') }
                    <h2>CASELOAD MANAGER</h2>
                    <p>Use this space to get a quick snapshot of your school's observation progress.</p>
                    <p>This serves to inform evaluators' pacing through observations.</p>`,
                tooltipClass: 'hide-skip'
            },
            { 
                element: '#role-view',
                intro: `${ onboardingHelper().closeIconText('doneAdminLandingPageOnboarding') }
                    <h2>CASELOAD MANAGER</h2>
                    <p>The table below shows Teacher or Evaluator specific data. Click the Evaluator tab to change the view.</p>
                    <p>Use this feature to decide when to schedule observations.</p>`,
                tooltipClass: 'hide-skip'
            },
            { 
                element: '.filters',
                intro: `${ onboardingHelper().closeIconText('doneAdminLandingPageOnboarding') }
                    <h2>CASELOAD MANAGER</h2>
                    <p>Use the teacher view filters to select a combination of evaluator, grade, subject. In the evaluator view, you can filter for teacher experience, grade, subject, or TIP status.</p>
                    <p>Use these filters to guide your focus when scheduling observations or walk-throughs of your teachers.</p>`,
                tooltipClass: 'hide-skip'
            },
            { 
                element: '#need-help',
                intro: `${ onboardingHelper().closeIconText('doneAdminLandingPageOnboarding') }
                    <h2>CASELOAD MANAGER</h2>
                    <p>If you ever need a reminder, find the tutorial for each page in Growth Explorer here.</p>`,
                tooltipClass: 'last-step'
            }
        ],
        intersection(setA, setB) {
            let _intersection = new Set();
            for (let elem of setB) {
                if (setA.has(elem)) {
                    _intersection.add(elem);
                }
            }
            return _intersection
        },
        experienceListed(experienceYears, array) {
            let listed = false
            for (let item of array) {
                if (experienceYears > item.min && experienceYears < item.max) {
                    listed = true
                    break
                }
            }
            return listed
        }
    }
}